const menus = [
  {
    id: 1,
    name: "Naslovna",
    links: "/",
  },
  {
    id: 2,
    name: "Projekti",
    namesub: [
      {
        id: 1,
        sub: "CityX App",
        links: "/apps/cityx-app",
      },
      /*
      {
        id: 2,
        sub: "CityX Tour&Pass",
        links: "/apps/cityx-tour-pass",
      },
      */
      {
        id: 3,
        sub: "Sportter",
        links: "/apps/sportter",
      },
    ],
  },
  {
    id: 3,
    name: "Gdje smo dostupni?",
    namesub: [
      {
        id: 1,
        sub: "Gradovi",
        links: "/partners?type=cities",
      },
      {
        id: 2,
        sub: "Tvrtke",
        links: "/partners?type=companies",
        disabled: true,
      },
      {
        id: 2,
        sub: "Sportski klubovi",
        links: "/partners?type=clubs",
        disabled: true,
      },
    ],
  },
  {
    id: 5,
    name: "Novosti & Blog",
    namesub: [
      {
        id: 1,
        sub: "Novosti",
        links: "/news-list",
      },
      {
        id: 2,
        sub: "Mediji o nama",
        links: "/news-list-media",
      },
      {
        id: 3,
        sub: "Blog",
        links: "/blog-list",
      },
    ],
  },
  {
    id: 5,
    name: "O nama",
    namesub: [
      {
        id: 1,
        sub: "Profil tvrtke",
        links: "/about-us",
      },
      {
        id: 2,
        sub: "CityX Team",
        links: "/about/cityx-team",
      },
      {
        id: 3,
        sub: "Karijere",
        links: "/about/carees",
        namesub: [
          {
            id: 1,
            sub: "Prijava za posao",
            links: "/about/carees-job-application",
          },
        ],
      },

      {
        id: 4,
        sub: "Kontakt",
        links: "/contact",
      },
      {
        id: 5,
        sub: "Pravila privatnosti",
        links: "/about-privacy-policy",
      },
      {
        id: 6,
        sub: "Uvijeti korištenja",
        links: "/about-terms",
      },
    ],
  },
];

export default menus;
